import type { ReactNode } from "react";

/**
 * Marco de las pantallas sin sesión: el mismo del `LoginForm` (ADR 0104 §5,
 * ADR 0027). Una sola definición para que las tres no se desalineen.
 */
export function MarcoAuth({
  titulo,
  subtitulo,
  children,
}: {
  titulo: string;
  subtitulo?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-sm space-y-5 rounded-lg border border-neutral-200 bg-white p-8">
        <div>
          <h1 className="text-xl font-semibold text-neutral-900">{titulo}</h1>
          {subtitulo ? <p className="mt-1 text-sm text-neutral-600">{subtitulo}</p> : null}
        </div>
        {children}
      </div>
    </div>
  );
}

/** El botón principal del `LoginForm` (negro, ancho completo). */
export const CLASE_BOTON_AUTH =
  "block w-full rounded bg-neutral-900 px-3 py-2 text-center font-medium text-neutral-100 disabled:opacity-50";
